import { null as zNull } from "zod/v4";

export const disconnectRivoIntegration = {
  name: "disconnectRivoIntegration" as const,
  input: zNull(),
  output: zNull(),
};
